var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedTab.type == _vm.ItemCategoryTypes.MECH ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-other-labour-headings-component", {
              attrs: {
                name: _vm.mechCategoryObject?.displayName || "Mechanical",
                "is-full-width": _vm.isFullWidth,
                "is-quote-hour": _vm.isQuoteTypeHour,
                count: _vm.mechLength,
                "total-value": _vm.mechTotal,
                "hour-value": _vm.mechHourTotal,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.MECH),
                        group: {
                          name: _vm.ItemCategoryTypes.MECH,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.MECH
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.others,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "others", $$v)
                        },
                        expression: "innerValue.others",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.mechItems, function (item) {
                    return _c("quote-builder-other-labour-item", {
                      key: item.id,
                      attrs: {
                        "read-only-view": _vm.readOnlyView,
                        vehicle: _vm.vehicle,
                        "inner-value": _vm.innerValue,
                        "items-assessments": _vm.itemsAssessments,
                        "is-quote-type-hour": _vm.isQuoteTypeHour,
                        "is-full-width": _vm.isFullWidth,
                        item: item,
                        "edit-item-id": _vm.editItemObj.id,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        deleteItem: (item) => _vm.deleteItem(item),
                        updateValue: _vm.updateValue,
                        focusNextRow: (id) => _vm.$emit("focusNextRow", item),
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        itemRowClicked: (value, event, close) =>
                          _vm.$emit("handleItemRowClick", value, event, close),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem(
                        $event,
                        _vm.ItemCategoryTypes.MECH
                      )
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }